module.exports = __webpack_public_path__ + "img/slide_bg_03.93507426.png";